import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import en from '../../../international/translations/en';
import config from '../../../config';
import changePasswordValidate from './changePasswordValidate';
import { ChangePasswordForm } from 'components';
import { reduxForm } from 'redux-form';
import { changePassword, resetState } from '../../../redux/Account/changePassword';

class ChangePassword extends Component {

  static propTypes = {
    user: PropTypes.object,
    passwordSubmitSucceeded: PropTypes.bool.isRequired,
    passwordSubmitting: PropTypes.bool.isRequired,
    passwordErrorMessage: PropTypes.string.isRequired,
    passwordSuccessMessage: PropTypes.string.isRequired,
    dispatch: PropTypes.func,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.analytics.page('Account', 'Change Password');
  }

  componentWillUnmount() {
    this.props.dispatch(resetState());
  }

  onSubmit = (data) => {
    window.analytics.track('Clicked Update Password', {
      location: 'change-password'
    });
    this.props.dispatch(changePassword(data));
  }

  enableSubmit = () => {
    if (this.props.passwordSubmitSucceeded) {
      this.props.dispatch(resetState());
    }
  }

  render() {
    const {
      fields,
      handleSubmit,
      passwordSubmitting,
      passwordSubmitSucceeded,
      passwordErrorMessage,
      passwordSuccessMessage
    } = this.props;

    return (
      <div className="changePassword">
        <Helmet title={en.change_password.meta_title[config.company]} />
        <div className="changePassword__heading__container">
          <div className="changePassword__heading">
            {en.change_password.title}
          </div>
        </div>
        <div className="changePassword__body__container">
          <div className="account__card">
            <ChangePasswordForm
              fields={fields}
              onSubmit={handleSubmit(this.onSubmit)}
              enableSubmit={this.enableSubmit}
              passwordSubmitSucceeded={passwordSubmitSucceeded}
              passwordSubmitting={passwordSubmitting}
              passwordErrorMessage={passwordErrorMessage}
              passwordSuccessMessage={passwordSuccessMessage}
            />
          </div>
        </div>
      </div>

    );
  }
}

export default reduxForm({
  form: 'changePassword',
  fields: ['currentPassword', 'newPassword', 'confirmPassword', '_id'],
  validate: changePasswordValidate,
  destroyOnUnmount: true
},
state => ({
  initialValues: state.user,
  user: state.user,
  passwordSubmitting: state.password.changePasswordSubmitting,
  passwordSubmitSucceeded: state.password.changePasswordSuccess,
  passwordErrorMessage: state.password.passwordErrorMessage,
  passwordSuccessMessage: state.password.passwordSuccessMessage
}))(ChangePassword);
